import { Action } from '@ngrx/store';

export enum UserDetailActionTypes {
  GetUserDetail = '[User] Get UserDetail',
  GetUserDetailSuccess = '[User] Get UserDetail Success',
  GetUserDetailFailure = '[User] Get UserDetail Failure',
}

export class GetUserDetail implements Action {
  readonly type = UserDetailActionTypes.GetUserDetail;
  constructor(public payload: any) {}
}


export class GetMerchantDetailSuccess implements Action {
    readonly type = UserDetailActionTypes.GetUserDetailSuccess;
    constructor(public payload: any) {}
  }
  
  export class GetMerchantDetailFailure implements Action {
    readonly type = UserDetailActionTypes.GetUserDetailFailure;
    constructor(public payload: any) {}
  }

export type UserDetailActions =
GetUserDetail | GetMerchantDetailSuccess | GetMerchantDetailFailure;
